<template>
  <v-card :min-width="dialogWidth" class="cursor-default" rounded="xl">
    <v-card-text class="pb-0">
      <v-toolbar color="transparent" density="comfortable" height="36px">
        <div class="w-100 d-flex justify-space-between align-center">
          <v-toolbar-title>
            <div class="title-wrapper">
              <div class="title-text">
                {{ title }}
              </div>

              <div v-if="subtitle" class="subtitle-text">
                {{ subtitle }}
              </div>
            </div>
          </v-toolbar-title>

          <v-btn
            border
            density="comfortable"
            icon
            rounded="lg"
            size="small"
            @click="$emit('close')">
            <v-icon icon="mdi-window-close"></v-icon>
          </v-btn>
        </div>
      </v-toolbar>
    </v-card-text>
    <v-card-text>
      <v-form @submit.prevent>
        <div>
          <suspense @resolve="$emit('suspense-resolve')">
            <template #default>
              <slot name="default"></slot>
            </template>

            <template #fallback>
              <Skeleton />
            </template>
          </suspense>
          <submit-buttons
            v-if="!hideActionButtons"
            :cancel="() => $emit('close')"
            :cancel-label="cancelLabel"
            :disabled="disabled"
            :submit="() => $emit('submit')"
            :submit-label="submitLabel"
            class="mt-3" />
        </div>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script lang="ts">
import Skeleton from '@/components/Skeleton.vue'
import SubmitButtons from '@/components/SubmitButtons.vue'

export default {
  name: 'DialogTemplate',
  components: { SubmitButtons, Skeleton },
  emits: ['close', 'submit', 'suspense-resolve'],
  props: {
    title: {
      type: String,
    },
    subtitle: {
      type: String,
    },
    cancelLabel: {
      type: String,
      default: 'Відмінити',
    },
    submitLabel: {
      type: String,
      default: 'Підтвердити',
    },
    hideActionButtons: {
      type: Boolean,
    },
    dialogWidth: {
      type: String,
      default: '450px',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.title-wrapper {
  max-width: 80%;
}

.title-text {
  font-weight: 700;
  font-size: 18px;

  white-space: normal;
  word-break: break-word;
  overflow-wrap: anywhere;
}

.subtitle-text {
  font-size: 13px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.6);
}
</style>
